import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import errorLog from '@/utils/errorLog'
let config = {
  timeout: 60000, // request timeout
  withCredentials: false
}
const service = axios.create(config)

// request intercetor
service.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    // if (store.getters.token) {
    //   // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    //   // config.headers['Content-Type'] = 'application/x-www-form-urlencoded' // json格式的不需要
    //   config.headers['token'] = getToken('PC_TOKEN')
    //   config.headers['pageCode'] = getToken('PAGE_CODE')
    // }
    return config
  },
  (error) => {
    // Do something with request error
    // console.log(error + 111111) // for debug
    Promise.reject(error)
  }
)
service.interceptors.response.use(
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  (response) => {
    // console.log(response)
    const res = response.data
    if (response.status === 200) {
      //  || res.code === 119008 || res.code === 140008 || res.code === 140009 || res.code === 140011
      if (res.code === 0) {
        return res.data
      } else if (res.code === 190001) {
        MessageBox.confirm('超时未操作，系统已自动登出，请重新登录', '重新登录', {
          confirmButtonText: '重新登录',
          // cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          showCancelButton: false,
          closeOnClickModal: false, // 遮罩层点击不能关闭MessageBox
          beforeClose: (action, instance, done) => {
            // done()
            if (action === 'cancel') {
              // MessageBox.close()
              location.reload()
            } else {
              store.dispatch('FedLogOut').then(() => {
                location.reload() // 为了重新实例化vue-router对象 避免bug
                // this.$router.push({path: '/login'})
              })
            }
          }
        }).catch((err) => {
          console.log(err)
        })
        return Promise.reject(res.data || res.msg)
        // return false
      } else if (Object.keys(errorLog).includes(String(res.code))) {
        let code = String(res.code)
        Message({
          message: errorLog[code],
          type: 'error',
          duration: 3000
        })
        return Promise.reject(res.data || res.msg)
      } else {
        Message({
          message: res.data || res.msg,
          type: 'error',
          duration: 3000
        })
        return Promise.reject(res.data || res.msg)
      }
    } else {
      Message({
        message: res.data || res.msg,
        type: 'error',
        duration: 3000
      })
      return Promise.reject(res.data || res.msg)
    }
  },
  (err) => {
    // console.log(err.response) // for debug
    Message({
      message: err.response.data.msg || '网络出错~~',
      type: 'error',
      duration: 5000
    })
    return Promise.reject(err)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js